import ChantiersGrillesController from './chantiers.grilles.controller';

export default {
    template: require('./chantiers.grilles.tpl.html'),
    controller: ChantiersGrillesController
};
